// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wFtZK","content":"styles_content__ikIIQ"};